import {
    AREA_CODES,
    ECountryCode,
} from 'src/modules/forms/fields/AreaCodeTextField/components/AreaCodeSelect';

/**
 * Detects country code from digits-only phone (longest matching prefix wins).
 * Mexico mobile numbers may arrive as 521XXXXXXXXXX.
 */
export const getCountryCodeFromPhone = (
    digitsOnly: string,
    fallback: ECountryCode = ECountryCode.Mexico
): ECountryCode => {
    if (!digitsOnly) return fallback;

    if (digitsOnly.startsWith('521')) {
        return ECountryCode.Mexico;
    }

    const sortedAreas = Object.values(AREA_CODES).sort(
        (a, b) =>
            b.code.replace(/\D/g, '').length - a.code.replace(/\D/g, '').length
    );

    const matchedArea = sortedAreas.find((area) =>
        digitsOnly.startsWith(area.code.replace('+', ''))
    );

    return matchedArea?.countryCode || fallback;
};
